import { getType, isType } from '@utils';

/**
 * visible
 * @param rootStore
 * @param options {}
 * @returns
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export const visible = {
  state: false,
  setState(state: boolean) {
    if (isType(state, 'Boolean')) {
      this.state = state;
    }
  },
  async doAction (rootStore: any, options: any = {}, event: any) {
    this.setState([event, options.state, !this.state].filter(v => isType(v, 'Boolean'))[0]);
  }
}